export default "__VITE_ASSET__B53ifpBi__"